import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { combineLatest } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { selectConfiguration, selectIsGisTokenRegistered } from '../../authentication/store/user.selector';
import WebMap from '@arcgis/core/WebMap';
import MapView from '@arcgis/core/views/MapView';
import { createMapViewCleaner } from '../utility/map-view-memory';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'sibat-web-map-page',
  template: `
    @if (!tokenReady) {
    <mat-spinner></mat-spinner>
    }
    <div #mapContainer class="map-container" [class.hidden]="!tokenReady"></div>
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        flex-grow: 1;
      }
      .map-container {
        width: 100%;
        height: 100%;
      }
      .hidden {
        display: none;
      }
    `,
  ],
  imports: [MatProgressSpinner],
})
export class WebMapPageComponent implements OnInit, OnDestroy {
  @ViewChild('mapContainer', { static: true }) mapContainer!: ElementRef;

  view?: MapView;
  tokenReady = false;
  readonly mapViewCleaner = createMapViewCleaner();

  private tokenSubscription?: Subscription;

  constructor(private store: Store) {}

  ngOnInit() {
    this.tokenSubscription = combineLatest([
      this.store.select(selectIsGisTokenRegistered).pipe(filter(Boolean)),
      this.store.select(selectConfiguration).pipe(filter(Boolean)),
    ])
      .pipe(take(1))
      .subscribe(([_, config]) => {
        this.tokenReady = true;
        this.initMap(config.portalUrl, config.webMapItemId);
      });
  }

  ngOnDestroy() {
    this.tokenSubscription?.unsubscribe();
    this.mapViewCleaner.cleanup(this);
  }

  private initMap(portalUrl: string, webMapItemId: string) {
    const webmap = new WebMap({
      portalItem: {
        id: webMapItemId,
        portal: { url: `${portalUrl}/portal` },
      },
    });

    this.view = new MapView({
      map: webmap,
      container: this.mapContainer.nativeElement,
    });
  }
}
